import OutputCanEditor from './OutputCanEditor'

export default OutputCanEditor
